var Vt = Object.defineProperty;
var Nt = (t, o, n) => o in t ? Vt(t, o, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[o] = n;
var Pe = (t, o, n) => Nt(t, typeof o != "symbol" ? o + "" : o, n);
import ve, { useEffect as O, useLayoutEffect as Ht, useState as L, useMemo as K, useRef as J, createContext as Ae, Fragment as S, forwardRef as Bt, isValidElement as it, useCallback as zt, useContext as ke } from "react";
import { Portal as Xt, Transition as Qe } from "@headlessui/react";
import { arrow as qt, useFloating as Jt } from "@floating-ui/react";
import { offset as Kt, flip as Gt, shift as Zt, autoPlacement as Qt, hide as er, autoUpdate as tr } from "@floating-ui/dom";
var Fe = { exports: {} }, re = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var et;
function rr() {
  if (et) return re;
  et = 1;
  var t = ve, o = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, s = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, l = { key: !0, ref: !0, __self: !0, __source: !0 };
  function u(g, d, w) {
    var f, v = {}, R = null, b = null;
    w !== void 0 && (R = "" + w), d.key !== void 0 && (R = "" + d.key), d.ref !== void 0 && (b = d.ref);
    for (f in d) r.call(d, f) && !l.hasOwnProperty(f) && (v[f] = d[f]);
    if (g && g.defaultProps) for (f in d = g.defaultProps, d) v[f] === void 0 && (v[f] = d[f]);
    return { $$typeof: o, type: g, key: R, ref: b, props: v, _owner: s.current };
  }
  return re.Fragment = n, re.jsx = u, re.jsxs = u, re;
}
var ne = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var tt;
function nr() {
  return tt || (tt = 1, process.env.NODE_ENV !== "production" && function() {
    var t = ve, o = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), s = Symbol.for("react.strict_mode"), l = Symbol.for("react.profiler"), u = Symbol.for("react.provider"), g = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), w = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), v = Symbol.for("react.memo"), R = Symbol.for("react.lazy"), b = Symbol.for("react.offscreen"), E = Symbol.iterator, C = "@@iterator";
    function W(e) {
      if (e === null || typeof e != "object")
        return null;
      var i = E && e[E] || e[C];
      return typeof i == "function" ? i : null;
    }
    var D = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function _(e) {
      {
        for (var i = arguments.length, a = new Array(i > 1 ? i - 1 : 0), c = 1; c < i; c++)
          a[c - 1] = arguments[c];
        V("error", e, a);
      }
    }
    function V(e, i, a) {
      {
        var c = D.ReactDebugCurrentFrame, p = c.getStackAddendum();
        p !== "" && (i += "%s", a = a.concat([p]));
        var x = a.map(function(m) {
          return String(m);
        });
        x.unshift("Warning: " + i), Function.prototype.apply.call(console[e], console, x);
      }
    }
    var N = !1, j = !1, Y = !1, H = !1, ae = !1, G;
    G = Symbol.for("react.module.reference");
    function Z(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === r || e === l || ae || e === s || e === w || e === f || H || e === b || N || j || Y || typeof e == "object" && e !== null && (e.$$typeof === R || e.$$typeof === v || e.$$typeof === u || e.$$typeof === g || e.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      e.$$typeof === G || e.getModuleId !== void 0));
    }
    function Q(e, i, a) {
      var c = e.displayName;
      if (c)
        return c;
      var p = i.displayName || i.name || "";
      return p !== "" ? a + "(" + p + ")" : a;
    }
    function B(e) {
      return e.displayName || "Context";
    }
    function A(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && _("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case l:
          return "Profiler";
        case s:
          return "StrictMode";
        case w:
          return "Suspense";
        case f:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case g:
            var i = e;
            return B(i) + ".Consumer";
          case u:
            var a = e;
            return B(a._context) + ".Provider";
          case d:
            return Q(e, e.render, "ForwardRef");
          case v:
            var c = e.displayName || null;
            return c !== null ? c : A(e.type) || "Memo";
          case R: {
            var p = e, x = p._payload, m = p._init;
            try {
              return A(m(x));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var M = Object.assign, z = 0, he, ge, me, ye, be, we, se;
    function Ye() {
    }
    Ye.__reactDisabledLog = !0;
    function gt() {
      {
        if (z === 0) {
          he = console.log, ge = console.info, me = console.warn, ye = console.error, be = console.group, we = console.groupCollapsed, se = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: Ye,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        z++;
      }
    }
    function mt() {
      {
        if (z--, z === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: M({}, e, {
              value: he
            }),
            info: M({}, e, {
              value: ge
            }),
            warn: M({}, e, {
              value: me
            }),
            error: M({}, e, {
              value: ye
            }),
            group: M({}, e, {
              value: be
            }),
            groupCollapsed: M({}, e, {
              value: we
            }),
            groupEnd: M({}, e, {
              value: se
            })
          });
        }
        z < 0 && _("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ee = D.ReactCurrentDispatcher, pe;
    function ue(e, i, a) {
      {
        if (pe === void 0)
          try {
            throw Error();
          } catch (p) {
            var c = p.stack.trim().match(/\n( *(at )?)/);
            pe = c && c[1] || "";
          }
        return `
` + pe + e;
      }
    }
    var Re = !1, ce;
    {
      var yt = typeof WeakMap == "function" ? WeakMap : Map;
      ce = new yt();
    }
    function Le(e, i) {
      if (!e || Re)
        return "";
      {
        var a = ce.get(e);
        if (a !== void 0)
          return a;
      }
      var c;
      Re = !0;
      var p = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var x;
      x = Ee.current, Ee.current = null, gt();
      try {
        if (i) {
          var m = function() {
            throw Error();
          };
          if (Object.defineProperty(m.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(m, []);
            } catch (k) {
              c = k;
            }
            Reflect.construct(e, [], m);
          } else {
            try {
              m.call();
            } catch (k) {
              c = k;
            }
            e.call(m.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (k) {
            c = k;
          }
          e();
        }
      } catch (k) {
        if (k && c && typeof k.stack == "string") {
          for (var h = k.stack.split(`
`), F = c.stack.split(`
`), T = h.length - 1, P = F.length - 1; T >= 1 && P >= 0 && h[T] !== F[P]; )
            P--;
          for (; T >= 1 && P >= 0; T--, P--)
            if (h[T] !== F[P]) {
              if (T !== 1 || P !== 1)
                do
                  if (T--, P--, P < 0 || h[T] !== F[P]) {
                    var I = `
` + h[T].replace(" at new ", " at ");
                    return e.displayName && I.includes("<anonymous>") && (I = I.replace("<anonymous>", e.displayName)), typeof e == "function" && ce.set(e, I), I;
                  }
                while (T >= 1 && P >= 0);
              break;
            }
        }
      } finally {
        Re = !1, Ee.current = x, mt(), Error.prepareStackTrace = p;
      }
      var q = e ? e.displayName || e.name : "", U = q ? ue(q) : "";
      return typeof e == "function" && ce.set(e, U), U;
    }
    function bt(e, i, a) {
      return Le(e, !1);
    }
    function wt(e) {
      var i = e.prototype;
      return !!(i && i.isReactComponent);
    }
    function le(e, i, a) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return Le(e, wt(e));
      if (typeof e == "string")
        return ue(e);
      switch (e) {
        case w:
          return ue("Suspense");
        case f:
          return ue("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case d:
            return bt(e.render);
          case v:
            return le(e.type, i, a);
          case R: {
            var c = e, p = c._payload, x = c._init;
            try {
              return le(x(p), i, a);
            } catch {
            }
          }
        }
      return "";
    }
    var ee = Object.prototype.hasOwnProperty, Me = {}, Ue = D.ReactDebugCurrentFrame;
    function fe(e) {
      if (e) {
        var i = e._owner, a = le(e.type, e._source, i ? i.type : null);
        Ue.setExtraStackFrame(a);
      } else
        Ue.setExtraStackFrame(null);
    }
    function Et(e, i, a, c, p) {
      {
        var x = Function.call.bind(ee);
        for (var m in e)
          if (x(e, m)) {
            var h = void 0;
            try {
              if (typeof e[m] != "function") {
                var F = Error((c || "React class") + ": " + a + " type `" + m + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[m] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw F.name = "Invariant Violation", F;
              }
              h = e[m](i, m, c, a, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (T) {
              h = T;
            }
            h && !(h instanceof Error) && (fe(p), _("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", c || "React class", a, m, typeof h), fe(null)), h instanceof Error && !(h.message in Me) && (Me[h.message] = !0, fe(p), _("Failed %s type: %s", a, h.message), fe(null));
          }
      }
    }
    var pt = Array.isArray;
    function xe(e) {
      return pt(e);
    }
    function Rt(e) {
      {
        var i = typeof Symbol == "function" && Symbol.toStringTag, a = i && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return a;
      }
    }
    function xt(e) {
      try {
        return Ve(e), !1;
      } catch {
        return !0;
      }
    }
    function Ve(e) {
      return "" + e;
    }
    function Ne(e) {
      if (xt(e))
        return _("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Rt(e)), Ve(e);
    }
    var te = D.ReactCurrentOwner, Ct = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, He, Be, Ce;
    Ce = {};
    function _t(e) {
      if (ee.call(e, "ref")) {
        var i = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (i && i.isReactWarning)
          return !1;
      }
      return e.ref !== void 0;
    }
    function jt(e) {
      if (ee.call(e, "key")) {
        var i = Object.getOwnPropertyDescriptor(e, "key").get;
        if (i && i.isReactWarning)
          return !1;
      }
      return e.key !== void 0;
    }
    function Tt(e, i) {
      if (typeof e.ref == "string" && te.current && i && te.current.stateNode !== i) {
        var a = A(te.current.type);
        Ce[a] || (_('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', A(te.current.type), e.ref), Ce[a] = !0);
      }
    }
    function St(e, i) {
      {
        var a = function() {
          He || (He = !0, _("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", i));
        };
        a.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: a,
          configurable: !0
        });
      }
    }
    function Pt(e, i) {
      {
        var a = function() {
          Be || (Be = !0, _("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", i));
        };
        a.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: a,
          configurable: !0
        });
      }
    }
    var Ot = function(e, i, a, c, p, x, m) {
      var h = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: o,
        // Built-in properties that belong on the element
        type: e,
        key: i,
        ref: a,
        props: m,
        // Record the component responsible for creating this element.
        _owner: x
      };
      return h._store = {}, Object.defineProperty(h._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(h, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: c
      }), Object.defineProperty(h, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: p
      }), Object.freeze && (Object.freeze(h.props), Object.freeze(h)), h;
    };
    function Ft(e, i, a, c, p) {
      {
        var x, m = {}, h = null, F = null;
        a !== void 0 && (Ne(a), h = "" + a), jt(i) && (Ne(i.key), h = "" + i.key), _t(i) && (F = i.ref, Tt(i, p));
        for (x in i)
          ee.call(i, x) && !Ct.hasOwnProperty(x) && (m[x] = i[x]);
        if (e && e.defaultProps) {
          var T = e.defaultProps;
          for (x in T)
            m[x] === void 0 && (m[x] = T[x]);
        }
        if (h || F) {
          var P = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          h && St(m, P), F && Pt(m, P);
        }
        return Ot(e, h, F, p, c, te.current, m);
      }
    }
    var _e = D.ReactCurrentOwner, ze = D.ReactDebugCurrentFrame;
    function X(e) {
      if (e) {
        var i = e._owner, a = le(e.type, e._source, i ? i.type : null);
        ze.setExtraStackFrame(a);
      } else
        ze.setExtraStackFrame(null);
    }
    var je;
    je = !1;
    function Te(e) {
      return typeof e == "object" && e !== null && e.$$typeof === o;
    }
    function Xe() {
      {
        if (_e.current) {
          var e = A(_e.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function At(e) {
      return "";
    }
    var qe = {};
    function kt(e) {
      {
        var i = Xe();
        if (!i) {
          var a = typeof e == "string" ? e : e.displayName || e.name;
          a && (i = `

Check the top-level render call using <` + a + ">.");
        }
        return i;
      }
    }
    function Je(e, i) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = !0;
        var a = kt(i);
        if (qe[a])
          return;
        qe[a] = !0;
        var c = "";
        e && e._owner && e._owner !== _e.current && (c = " It was passed a child from " + A(e._owner.type) + "."), X(e), _('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', a, c), X(null);
      }
    }
    function Ke(e, i) {
      {
        if (typeof e != "object")
          return;
        if (xe(e))
          for (var a = 0; a < e.length; a++) {
            var c = e[a];
            Te(c) && Je(c, i);
          }
        else if (Te(e))
          e._store && (e._store.validated = !0);
        else if (e) {
          var p = W(e);
          if (typeof p == "function" && p !== e.entries)
            for (var x = p.call(e), m; !(m = x.next()).done; )
              Te(m.value) && Je(m.value, i);
        }
      }
    }
    function Dt(e) {
      {
        var i = e.type;
        if (i == null || typeof i == "string")
          return;
        var a;
        if (typeof i == "function")
          a = i.propTypes;
        else if (typeof i == "object" && (i.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        i.$$typeof === v))
          a = i.propTypes;
        else
          return;
        if (a) {
          var c = A(i);
          Et(a, e.props, "prop", c, e);
        } else if (i.PropTypes !== void 0 && !je) {
          je = !0;
          var p = A(i);
          _("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", p || "Unknown");
        }
        typeof i.getDefaultProps == "function" && !i.getDefaultProps.isReactClassApproved && _("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function It(e) {
      {
        for (var i = Object.keys(e.props), a = 0; a < i.length; a++) {
          var c = i[a];
          if (c !== "children" && c !== "key") {
            X(e), _("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", c), X(null);
            break;
          }
        }
        e.ref !== null && (X(e), _("Invalid attribute `ref` supplied to `React.Fragment`."), X(null));
      }
    }
    var Ge = {};
    function Ze(e, i, a, c, p, x) {
      {
        var m = Z(e);
        if (!m) {
          var h = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (h += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var F = At();
          F ? h += F : h += Xe();
          var T;
          e === null ? T = "null" : xe(e) ? T = "array" : e !== void 0 && e.$$typeof === o ? (T = "<" + (A(e.type) || "Unknown") + " />", h = " Did you accidentally export a JSX literal instead of a component?") : T = typeof e, _("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", T, h);
        }
        var P = Ft(e, i, a, p, x);
        if (P == null)
          return P;
        if (m) {
          var I = i.children;
          if (I !== void 0)
            if (c)
              if (xe(I)) {
                for (var q = 0; q < I.length; q++)
                  Ke(I[q], e);
                Object.freeze && Object.freeze(I);
              } else
                _("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Ke(I, e);
        }
        if (ee.call(i, "key")) {
          var U = A(e), k = Object.keys(i).filter(function(Ut) {
            return Ut !== "key";
          }), Se = k.length > 0 ? "{key: someKey, " + k.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Ge[U + Se]) {
            var Mt = k.length > 0 ? "{" + k.join(": ..., ") + ": ...}" : "{}";
            _(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Se, U, Mt, U), Ge[U + Se] = !0;
          }
        }
        return e === r ? It(P) : Dt(P), P;
      }
    }
    function $t(e, i, a) {
      return Ze(e, i, a, !0);
    }
    function Wt(e, i, a) {
      return Ze(e, i, a, !1);
    }
    var Yt = Wt, Lt = $t;
    ne.Fragment = r, ne.jsx = Yt, ne.jsxs = Lt;
  }()), ne;
}
process.env.NODE_ENV === "production" ? Fe.exports = rr() : Fe.exports = nr();
var y = Fe.exports;
function ir(t) {
  return typeof window > "u" ? 1 : (t.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function rt(t, o) {
  const n = ir(t);
  return Math.round(o * n) / n;
}
class or {
  constructor() {
    Pe(this, "current", this.detect());
    Pe(this, "currentId", 0);
  }
  set(o) {
    this.current !== o && (this.currentId = 0, this.current = o);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
}
const ie = new or(), ot = (t, o) => {
  ie.isServer ? O(t, o) : Ht(t, o);
}, Oe = { serverHandoffComplete: !1 };
function ar() {
  const [t, o] = L(Oe.serverHandoffComplete);
  return O(() => {
    t !== !0 && o(!0);
  }, [t]), O(() => {
    Oe.serverHandoffComplete === !1 && (Oe.serverHandoffComplete = !0);
  }, []), t;
}
const sr = (
  // Prefer React's `useId` if it's available.
  ve.useId ?? function() {
    const o = ar(), [n, r] = ve.useState(o ? () => ie.nextId() : null);
    return ot(() => {
      n === null && r(ie.nextId());
    }, [n]), n != null ? `${n}` : void 0;
  }
);
function ur(t, o, n, r) {
  O(() => {
    const s = [];
    (typeof r.offset == "number" || typeof r.offset == "object" || typeof r.offset == "function") && s.push(Kt(r.offset)), (r.flip === !0 || typeof r.flip == "number" || typeof r.flip == "object") && s.push(Gt({
      padding: typeof r.flip == "number" ? r.flip : void 0,
      ...typeof r.flip == "object" ? r.flip : {}
    })), (r.shift === !0 || typeof r.shift == "number" || typeof r.shift == "object") && s.push(Zt({
      padding: typeof r.shift == "number" ? r.shift : void 0,
      ...typeof r.shift == "object" ? r.shift : {}
    })), (r.autoPlacement === !0 || typeof r.autoPlacement == "object") && s.push(Qt(
      typeof r.autoPlacement == "object" ? r.autoPlacement : void 0
    )), s.push(...typeof r.middleware == "function" ? r.middleware({
      referenceEl: o.reference,
      floatingEl: o.floating
    }) : r.middleware || []), (r.arrow === !0 || typeof r.arrow == "number") && s.push(qt({
      element: n,
      padding: r.arrow === !0 ? 0 : r.arrow
    })), (r.hide === !0 || typeof r.hide == "object" || Array.isArray(r.hide)) && (Array.isArray(r.hide) ? r.hide : [r.hide]).forEach((l) => {
      s.push(er(
        typeof l == "object" ? l : void 0
      ));
    }), t(s);
  }, [
    r.offset,
    r.shift,
    r.flip,
    r.arrow,
    r.autoPlacement,
    r.hide,
    r.middleware
  ]);
}
function cr(t, o, n) {
  O(() => {
    if (t && ie.isClient && typeof ResizeObserver < "u" && o.current && o.current instanceof Element) {
      const r = new ResizeObserver(([s]) => {
        const l = s.borderBoxSize.reduce((u, { inlineSize: g }) => u + g, 0);
        n(l);
      });
      return r.observe(o.current), () => {
        r.disconnect(), n(null);
      };
    }
  }, []);
}
const _r = [
  "origin-bottom",
  "origin-top",
  "origin-right",
  "origin-left",
  "origin-bottom-left",
  "origin-bottom-right",
  "origin-top-left",
  "origin-top-right"
], lr = (t) => {
  switch (t) {
    case "top":
      return "origin-bottom";
    case "bottom":
      return "origin-top";
    case "left":
      return "origin-right";
    case "right":
      return "origin-left";
    case "top-start":
    case "right-end":
      return "origin-bottom-left";
    case "top-end":
    case "left-end":
      return "origin-bottom-right";
    case "right-start":
    case "bottom-start":
      return "origin-top-left";
    case "left-start":
    case "bottom-end":
      return "origin-top-right";
    default:
      return "origin-center";
  }
}, jr = [
  "origin-bottom",
  "origin-top",
  "ltr:origin-right rtl:origin-left",
  "ltr:origin-left rtl:origin-right",
  "ltr:origin-bottom-left rtl:origin-bottom-right",
  "ltr:origin-bottom-right rtl:origin-bottom-left",
  "ltr:origin-top-left rtl:origin-top-right",
  "ltr:origin-top-right rtl:origin-top-left"
], Tr = (t) => {
  switch (t) {
    case "top":
      return "origin-bottom";
    case "bottom":
      return "origin-top";
    case "left":
      return "ltr:origin-right rtl:origin-left";
    case "right":
      return "ltr:origin-left rtl:origin-right";
    case "top-start":
    case "right-end":
      return "ltr:origin-bottom-left rtl:origin-bottom-right";
    case "top-end":
    case "left-end":
      return "ltr:origin-bottom-right rtl:origin-bottom-left";
    case "right-start":
    case "bottom-start":
      return "ltr:origin-top-left rtl:origin-top-right";
    case "left-start":
    case "bottom-end":
      return "ltr:origin-top-right rtl:origin-top-left";
    default:
      return "origin-center";
  }
};
function fr(t, o) {
  return K(() => typeof t.originClass == "function" ? t.originClass(o) : typeof t.originClass == "string" ? t.originClass : t.tailwindcssOriginClass ? lr(o) : "", [o, t.originClass, t.tailwindcssOriginClass]);
}
function at(t, o, ...n) {
  if (t in o) {
    const s = o[t];
    return typeof s == "function" ? s(...n) : s;
  }
  const r = new Error(
    `Tried to handle "${t}" but there is no handler defined. Only defined handlers are: ${Object.keys(
      o
    ).map((s) => `"${s}"`).join(", ")}.`
  );
  throw Error.captureStackTrace && Error.captureStackTrace(r, at), r;
}
function st(t) {
  return ie.isServer ? null : t instanceof Node ? t.ownerDocument : t && Object.prototype.hasOwnProperty.call(t, "current") && t.current instanceof Node ? t.current.ownerDocument : document;
}
const nt = [
  "[contentEditable=true]",
  "[tabindex]",
  "a[href]",
  "area[href]",
  "button:not([disabled])",
  "iframe",
  "input:not([disabled])",
  "select:not([disabled])",
  "textarea:not([disabled])"
].map(
  // TODO: Remove this once JSDOM fixes the issue where an element that is
  // "hidden" can be the document.activeElement, because this is not possible
  // in real browsers.
  process.env.NODE_ENV === "test" ? (t) => `${t}:not([tabindex='-1']):not([style*='display: none'])` : (t) => `${t}:not([tabindex='-1'])`
).join(",");
var ut = /* @__PURE__ */ ((t) => (t[t.Strict = 0] = "Strict", t[t.Loose = 1] = "Loose", t))(ut || {});
function dr(t, o = 0) {
  var n;
  return t === ((n = st(t)) == null ? void 0 : n.body) ? !1 : at(o, {
    0() {
      return t.matches(nt);
    },
    1() {
      let r = t;
      for (; r !== null; ) {
        if (r.matches(nt)) return !0;
        r = r.parentElement;
      }
      return !1;
    }
  });
}
function vr(t) {
  const o = J(t);
  return ot(() => {
    o.current = t;
  }, [t]), o;
}
function $(t, o, n) {
  const r = vr(o);
  O(() => {
    function s(l) {
      r.current(l);
    }
    return document.addEventListener(t, s, n), () => document.removeEventListener(t, s, n);
  }, [t, n]);
}
function hr(t, o, n = !0) {
  const r = J(!1);
  O(
    process.env.NODE_ENV === "test" ? () => {
      r.current = n;
    } : () => {
      requestAnimationFrame(() => {
        r.current = n;
      });
    },
    [n]
  );
  function s(u, g) {
    if (!r.current || u.defaultPrevented) return;
    const d = function f(v) {
      return typeof v == "function" ? f(v()) : Array.isArray(v) || v instanceof Set ? v : [v];
    }(t), w = g(u);
    if (w !== null && w.getRootNode().contains(w)) {
      for (const f of d) {
        if (f === null) continue;
        const v = f instanceof HTMLElement ? f : f.current;
        if (v != null && v.contains(w) || u.composed && u.composedPath().includes(v))
          return;
      }
      return (
        // This check alllows us to know whether or not we clicked on a "focusable" element like a
        // button or an input. This is a backwards compatibility check so that you can open a <Menu
        // /> and click on another <Menu /> which should close Menu A and open Menu B. We might
        // revisit that so that you will require 2 clicks instead.
        !dr(w, ut.Loose) && // This could be improved, but the `Combobox.Button` adds tabIndex={-1} to make it
        // unfocusable via the keyboard so that tabbing to the next item from the input doesn't
        // first go to the button.
        w.tabIndex !== -1 && u.preventDefault(), o(u, w)
      );
    }
  }
  const l = J(null);
  $("mousedown", (u) => {
    var g, d;
    r.current && (l.current = ((d = (g = u.composedPath) == null ? void 0 : g.call(u)) == null ? void 0 : d[0]) || u.target);
  }, !0), $(
    "click",
    (u) => {
      l.current && (s(u, () => l.current), l.current = null);
    },
    // We will use the `capture` phase so that layers in between with `event.stopPropagation()`
    // don't "cancel" this outside click check. E.g.: A `Menu` inside a `DialogPanel` if the `Menu`
    // is open, and you click outside of it in the `DialogPanel` the `Menu` should close. However,
    // the `DialogPanel` has a `onClick(e) { e.stopPropagation() }` which would cancel this.
    !0
  ), $("blur", (u) => s(
    u,
    () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null
  ), !0);
}
const de = /* @__PURE__ */ new Map(), De = Ae(null);
De.displayName = "ReferenceContext";
const Ie = Ae(null);
Ie.displayName = "FloatingContext";
const oe = Ae(null);
oe.displayName = "ArrowContext";
function ct(t) {
  const o = ke(De);
  if (o === null) {
    const n = new Error(`<${t} /> is missing a parent <Float /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, ct), n;
  }
  return o;
}
function lt(t) {
  const o = ke(Ie);
  if (o === null) {
    const n = new Error(`<${t} /> is missing a parent <Float /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, lt), n;
  }
  return o;
}
function ft(t) {
  const o = ke(oe);
  if (o === null) {
    const n = new Error(`<${t} /> is missing a parent <Float /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, ft), n;
  }
  return o;
}
function dt(t, o, { key: n, ...r }, s) {
  const { referenceRef: l } = s, u = o;
  if (u.as === S)
    return /* @__PURE__ */ y.jsx(
      t.type,
      {
        ...t.props,
        ...r,
        ref: l
      },
      n
    );
  const g = u.as || "div";
  return /* @__PURE__ */ y.jsx(g, { ...r, ref: l, children: /* @__PURE__ */ y.jsx(t.type, { ...t.props }) }, n);
}
function $e(t, o, { key: n, ...r }, s) {
  const { floatingRef: l, props: u, mounted: g, setShow: d, referenceHidden: w, escaped: f, placement: v, floatingStyles: R, referenceElWidth: b } = s, E = {
    ...u,
    ...o
  }, C = fr(E, v), W = {
    show: g.current ? E.show : !1,
    unmount: t.props.unmount === !1 ? !1 : void 0,
    enter: `${E.enter || ""} ${C}`,
    enterFrom: `${E.enterFrom || ""}`,
    enterTo: `${E.enterTo || ""}`,
    leave: `${E.leave || ""} ${C}`,
    leaveFrom: `${E.leaveFrom || ""}`,
    leaveTo: `${E.leaveTo || ""}`,
    beforeEnter: () => {
      d(!0);
    },
    afterLeave: () => {
      d(!1);
    }
  }, D = {
    className: [
      w ? E.referenceHiddenClass : void 0,
      f ? E.escapedClass : void 0
    ].filter((j) => !!j).join(" "),
    style: {
      ...R,
      zIndex: E.zIndex || 9999
    }
  };
  if (E.adaptiveWidth && typeof b == "number") {
    const j = {
      attribute: "width",
      ...typeof E.adaptiveWidth == "object" ? E.adaptiveWidth : {}
    };
    D.style[j.attribute] = `${b}px`;
  }
  function _(j) {
    return E.portal ? g.current ? /* @__PURE__ */ y.jsx(Xt, { children: j }) : /* @__PURE__ */ y.jsx(S, {}) : j;
  }
  function V(j) {
    const Y = {
      ...D,
      ...r,
      ref: l
    };
    if (j.type === S)
      return /* @__PURE__ */ y.jsx(S, {});
    if (E.as === S)
      return /* @__PURE__ */ y.jsx(
        j.type,
        {
          ...j.props,
          ...Y
        },
        n
      );
    const H = E.as || "div";
    return /* @__PURE__ */ y.jsx(H, { ...Y, children: /* @__PURE__ */ y.jsx(j.type, { ...j.props }) }, n);
  }
  function N() {
    return g.current ? E.transitionChild ? /* @__PURE__ */ y.jsx(Qe.Child, { as: S, ...W, children: /* @__PURE__ */ y.jsx(t.type, { ...t.props }) }) : /* @__PURE__ */ y.jsx(Qe, { as: S, ...W, children: /* @__PURE__ */ y.jsx(t.type, { ...t.props }) }) : /* @__PURE__ */ y.jsx(S, {});
  }
  return _(
    V(
      N()
    )
  );
}
function vt([t, o], n) {
  var Z, Q;
  const r = sr(), s = J(!1), [l, u] = L(), [g, d] = L(void 0), [w, f] = L(void 0), v = J(null), R = K(() => ({
    show: n.onShow || (() => {
    }),
    hide: n.onHide || (() => {
    }),
    update: n.onUpdate || (() => {
    })
  }), [n.onShow, n.onHide, n.onUpdate]), { placement: b, update: E, refs: C, floatingStyles: W, isPositioned: D, middlewareData: _ } = Jt({
    placement: n.placement || "bottom-start",
    strategy: n.strategy,
    middleware: l,
    transform: n.dialog ? !1 : n.transform ?? !1
    // If enable dialog mode, then set `transform` to false.
  }), [V, N] = L(null);
  O(() => {
    s.current = !0;
  }, []), O(() => {
    t && !de.get(r) ? (de.set(r, !0), R.show()) : !t && de.get(r) && (de.delete(r), R.hide());
  }, [t]);
  const j = zt(() => {
    E(), R.update();
  }, [E, R]);
  O(j, [n.placement, n.strategy, l]), ur(u, C, v, n), O(() => {
    var B, A;
    (n.hide === !0 || typeof n.hide == "object" || Array.isArray(n.hide)) && (d(((B = _.hide) == null ? void 0 : B.referenceHidden) || !D), f((A = _.hide) == null ? void 0 : A.escaped));
  }, [_, n.hide, D]), cr(!!n.adaptiveWidth, C.reference, N), O(() => {
    if (C.reference.current && C.floating.current && t)
      return n.autoUpdate !== !1 ? tr(
        C.reference.current,
        C.floating.current,
        j,
        typeof n.autoUpdate == "object" ? n.autoUpdate : void 0
      ) : () => {
      };
  }, [t, j, C]);
  const Y = J(!0);
  O(() => {
    !(C.reference.current instanceof Element) && C.reference.current && C.floating.current && Y.current && (Y.current = !1, j(), window.requestAnimationFrame(() => {
      Y.current = !0, j();
    }));
  }, [C]);
  const H = {
    referenceRef: C.setReference,
    placement: b
  }, ae = {
    floatingRef: C.setFloating,
    props: n,
    mounted: s,
    setShow: o,
    referenceHidden: g,
    escaped: w,
    placement: b,
    floatingStyles: W,
    referenceElWidth: V
  }, G = {
    arrowRef: v,
    placement: b,
    x: (Z = _.arrow) == null ? void 0 : Z.x,
    y: (Q = _.arrow) == null ? void 0 : Q.y
  };
  return { referenceApi: H, floatingApi: ae, arrowApi: G, placement: b, update: j, refs: C, middlewareData: _ };
}
const ht = Bt((t, o) => {
  const [n, r] = L(t.show ?? !1), {
    referenceApi: s,
    floatingApi: l,
    arrowApi: u,
    placement: g
  } = vt([n, r], t), d = { placement: g }, [w, f] = typeof t.children == "function" ? t.children(d) : t.children;
  if (!it(w))
    return console.warn("<Float /> is missing a reference and floating element."), /* @__PURE__ */ y.jsx(S, {});
  function v(E) {
    if (t.as === S || !t.as)
      return /* @__PURE__ */ y.jsx(S, { children: E });
    const C = t.as;
    return /* @__PURE__ */ y.jsx(C, { ref: o, className: t.className, children: E });
  }
  if (t.composable || t.dialog)
    return v(
      /* @__PURE__ */ y.jsx(De.Provider, { value: s, children: /* @__PURE__ */ y.jsx(Ie.Provider, { value: l, children: /* @__PURE__ */ y.jsx(oe.Provider, { value: u, children: typeof t.children == "function" ? t.children(d) : t.children }) }) }, "FloatingNode")
    );
  const R = dt(
    w,
    { as: S },
    { key: "reference-node" },
    s
  ), b = $e(
    f,
    { as: t.floatingAs || "div" },
    {},
    l
  );
  return v([
    R,
    /* @__PURE__ */ y.jsx(oe.Provider, { value: u, children: b }, "floating-node")
  ]);
});
ht.displayName = "Float";
function gr(t) {
  if (!t.children)
    return /* @__PURE__ */ y.jsx(S, {});
  const o = K(() => {
    const { as: l, children: u, ...g } = t;
    return g;
  }, [t]), n = ct("Float.Reference"), { placement: r } = n, s = { placement: r };
  return dt(
    typeof t.children == "function" ? t.children(s) : t.children,
    { ...t, as: t.as || S },
    o,
    n
  );
}
function mr(t) {
  if (!t.children)
    return /* @__PURE__ */ y.jsx(S, {});
  const o = K(() => {
    const { as: l, enter: u, enterFrom: g, enterTo: d, leave: w, leaveFrom: f, leaveTo: v, originClass: R, tailwindcssOriginClass: b, transitionChild: E, children: C, ...W } = t;
    return W;
  }, [t]), n = lt("Float.Content"), { placement: r } = n, s = { placement: r };
  return $e(
    typeof t.children == "function" ? t.children(s) : t.children,
    { ...t, as: t.as || "div" },
    o,
    n
  );
}
function yr(t) {
  const { arrowRef: o, placement: n, x: r, y: s } = ft("Float.Arrow"), l = K(() => {
    const { as: w, offset: f, children: v, ...R } = t;
    return R;
  }, [t]), u = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
  }[n.split("-")[0]], g = {
    left: o.current && typeof r == "number" ? `${rt(o.current, r)}px` : void 0,
    top: o.current && typeof s == "number" ? `${rt(o.current, s)}px` : void 0,
    right: void 0,
    bottom: void 0,
    [u]: `${(t.offset ?? 4) * -1}px`,
    ...l.style
  };
  if (t.as === S) {
    const w = { placement: n }, f = typeof t.children == "function" ? t.children(w) : t.children;
    return !f || !it(f) ? /* @__PURE__ */ y.jsx(S, {}) : /* @__PURE__ */ y.jsx(
      f.type,
      {
        ...f.props,
        ref: o,
        style: g
      }
    );
  }
  const d = t.as || "div";
  return /* @__PURE__ */ y.jsx(
    d,
    {
      ref: o,
      ...l,
      style: g,
      children: t.children
    }
  );
}
function We({ onInitial: t, children: o, ...n }) {
  const [r, s] = L(n.show ?? !1), l = K(() => {
    const { as: b, show: E, placement: C, strategy: W, offset: D, shift: _, flip: V, arrow: N, autoPlacement: j, autoUpdate: Y, zIndex: H, enter: ae, enterFrom: G, enterTo: Z, leave: Q, leaveFrom: B, leaveTo: A, originClass: M, tailwindcssOriginClass: z, portal: he, transform: ge, middleware: me, onShow: ye, onHide: be, onUpdate: we, ...se } = n;
    return se;
  }, [n]), {
    floatingApi: u,
    arrowApi: g,
    placement: d,
    refs: w
  } = vt([r, s], n);
  O(() => {
    s(n.show ?? !1);
  }, [n.show]);
  function f() {
    r && s(!1);
  }
  if (t({ show: r, setShow: s, placement: d, refs: w }), !o)
    return /* @__PURE__ */ y.jsx(S, {});
  const R = $e(
    typeof o == "function" ? o({ placement: d, close: f }) : o,
    {
      ...n,
      as: n.as || S,
      show: r
    },
    l,
    u
  );
  return /* @__PURE__ */ y.jsx(oe.Provider, { value: g, children: R });
}
function br(t) {
  const [o, n] = L(!1);
  function r({ setShow: s, refs: l }) {
    $("contextmenu", (u) => {
      u.preventDefault(), l.setPositionReference({
        getBoundingClientRect() {
          return {
            width: 0,
            height: 0,
            x: u.clientX,
            y: u.clientY,
            top: u.clientY,
            left: u.clientX,
            right: u.clientX,
            bottom: u.clientY
          };
        }
      }), s(!0);
    }), hr(l.floating, () => {
      s(!1);
    });
  }
  return O(() => (n(!0), () => {
    n(!1);
  }), []), o ? /* @__PURE__ */ y.jsx(
    We,
    {
      flip: !0,
      ...t,
      show: !1,
      portal: !0,
      onInitial: r
    }
  ) : /* @__PURE__ */ y.jsx(S, {});
}
function wr({ globalHideCursor: t, ...o }) {
  const [n, r] = L(!1);
  function s({ setShow: l, refs: u }) {
    function g() {
      l(!0);
    }
    function d() {
      l(!1);
    }
    function w(b) {
      u.setPositionReference({
        getBoundingClientRect() {
          return {
            width: 0,
            height: 0,
            x: b.clientX,
            y: b.clientY,
            top: b.clientY,
            left: b.clientX,
            right: b.clientX,
            bottom: b.clientY
          };
        }
      });
    }
    function f(b) {
      g(), w(b);
    }
    function v(b) {
      g(), w(b.touches[0]);
    }
    const R = st(u.floating);
    R && (O(() => {
      if ((t || t === void 0) && !R.getElementById("headlesui-float-cursor-style")) {
        const b = R.createElement("style");
        return (R.head || R.getElementsByTagName("head")[0]).appendChild(b), b.id = "headlesui-float-cursor-style", b.appendChild(R.createTextNode([
          "*, *::before, *::after {",
          "  cursor: none !important;",
          "}",
          ".headlesui-float-cursor-root {",
          "  pointer-events: none !important;",
          "}"
        ].join(`
`))), () => {
          var C;
          return (C = R.getElementById("headlesui-float-cursor-style")) == null ? void 0 : C.remove();
        };
      }
    }, [t]), "ontouchstart" in window || navigator.maxTouchPoints > 0 ? ($("touchstart", v), $("touchend", d), $("touchmove", v)) : ($("mouseenter", f), $("mouseleave", d), $("mousemove", f)));
  }
  return O(() => (r(!0), () => {
    r(!1);
  }), []), n ? /* @__PURE__ */ y.jsx(
    We,
    {
      ...o,
      portal: !0,
      className: "headlesui-float-cursor-root",
      onInitial: s
    }
  ) : /* @__PURE__ */ y.jsx(S, {});
}
const Sr = Object.assign(ht, { Reference: gr, Content: mr, Arrow: yr, Virtual: We, ContextMenu: br, Cursor: wr });
export {
  Sr as Float,
  $e as renderFloatingElement,
  dt as renderReferenceElement,
  lr as tailwindcssOriginClassResolver,
  _r as tailwindcssOriginSafelist,
  Tr as tailwindcssRtlOriginClassResolver,
  jr as tailwindcssRtlOriginSafelist,
  hr as useOutsideClick
};
